import { toRefs, computed, provide } from 'vue';
import { useModel } from '../../compositions/component-lib.esm15.js';
import { addOrRemove } from '../../utils/component-lib.esm7.js';

//
var script = {
  name: 'ListItemGroup',
  props: {
    value: {
      type: [Array, Number, String],
      default: null
    },
    ariaLabel: {
      type: String,
      required: true
    },
    multiple: Boolean,
    /** Limit the number of items that can be selected in multiple mode */
    multipleLimit: {
      type: Number,
      default: null
    }
  },
  setup(props, _ref) {
    let {
      emit
    } = _ref;
    const {
      value
    } = toRefs(props);
    const selected = useModel(value, val => emit('input', val));
    if (props.multiple && !Array.isArray(selected.value)) selected.value = [selected.value];
    const areUnselectedItemsDisabled = computed(() => {
      if (!props.multiple || props.multipleLimit === null) return false;
      return selected.value.length >= props.multipleLimit;
    });
    function onToggle(itemIndex) {
      if (props.multiple) {
        selected.value = addOrRemove(selected.value, itemIndex);
      } else {
        selected.value = itemIndex;
      }
    }
    provide('list-group', {
      isInGroup: true,
      selected,
      onToggle,
      areUnselectedItemsDisabled
    });
    return {};
  }
};
export { script as default };